import { MENSAJES_SISTEMA_SHOW } from '../actions/constants/mensajesSistema.constants';

const initialState = {
  title: '',
  user: null,
  permisos: null,
  type: null,
  level: null,
};

export default function mensajesSistema(state = initialState, { type, payload }) {
  switch (type) {
    case MENSAJES_SISTEMA_SHOW: {
      if (payload) {
        const currDate = new Date();
        const timestamp = currDate.getTime();
        const { type, httpError } = payload;

        if (httpError && typeof httpError === 'object') {
          const { response } = httpError;
          if (response) {
            const { data } = response;
            if(data) {
              const { error_message: errorMessage } = data;
              const message = `${errorMessage}`;
              return {
                timestamp,
                type: 'toast',
                message,
                level: 'danger',
              };
            }
          }
        }
        const { title, message, level } = payload;
        return {
          title, message, timestamp, type, level,
        };
      }
      return state;
    }
    default:
      return state;
  }
}
